<template>
  <b-modal
    id="modal_send_doc"
    ref="modal_send_doc"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModal"
  >
    <div class="col-md-12 col-sm-12">
      <label>Envio de documento</label>
      <b-form-file
        v-model="fileForm.file"
        multiple
        ref="file"
        :state="Boolean(fileForm.file)"
        placeholder="Selecione ou arraste o arquivo aqui"
        drop-placeholder="Solte aqui"
      ></b-form-file>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    rota: ""
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      data: [],
      fileForm: new FileForm({
        file: [],
        data: [],
        id: ""
      })
    };
  },

  methods: {
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Enviar Documento";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.fileForm.reset();
      console.log(data);
      this.fileForm.file = [];
      this.fileForm.id = data;
      this.$refs.modal_send_doc.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.data.push({ label: "arquivos[]", value: this.fileForm.file });
      this.data.push({ label: "id", value: this.fileForm.id });
      this.fileForm.data = this.data;
      this.fileForm
        .upload("/api/" + this.rota + "/enviofoto")
        .then(response => {
          new ReturnApi(response, this, null, false, true, true);
          this.$parent.onFilterReset();
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    }
  }
};
</script>
